import { Injectable, signal } from '@angular/core';
@Injectable()
export class DocumentDragState {
    public readonly source = signal<{ id: string; height: number } | undefined>(
        undefined
    );
    public minHeight(id: string, fallback = 32): number {
        const source = this.source();
        return source?.id === id ? source.height : fallback;
    }
}
